export default __webpack_public_path__ + "static/collage-304e7df17b4f6a326c4d24fb941b8402.png";